import styled from '@emotion/styled'
import Box from '../Box'
import { ActivityMetadataItemDesginType } from '../../types/activity.types'
import { Activity } from '../../../../pure-js/types/GrooverTypes'
import { SIXTEEN_PX } from '../../enums/Spacings'
import { getThemeConfig } from '../../themeConfig'

const FIELD_ID_MAP: Record<string, string> = {
  dayTime: 'time',
  startDate: 'time',
  occasions: 'occasions',
  price: 'price',
  instructors: 'instructors'
}

export const ActivityMetadataDesignType = ({
  activity,
  items,
  fields
}: {
  activity: Activity
  items: ActivityMetadataItemDesginType[]
  fields?: string[]
}) => {
  const themeConfig = getThemeConfig()
  const textColor = themeConfig.textColor || '#222'

  const shouldShowItem = (item: ActivityMetadataItemDesginType): boolean => {
    if (item.displayId === 'location') return false // location ID not user-friendly
    if (!fields) return true
    const fieldKey = FIELD_ID_MAP[item.displayId]
    return fieldKey ? fields.includes(fieldKey) : true
  }

  const showLevel = !fields || fields.includes('level')

  return (
    <Wrapper fullWidth>
      <Box fullWidth>
        {showLevel && activity.level && <LevelText $textcolor={textColor}>{activity.level}</LevelText>}
        {items.map((item) => {
          if (!shouldShowItem(item)) return null
          return (
            <MetadataRow key={item.displayId} fullWidth bottom spacing={SIXTEEN_PX}>
              <Value $textcolor={textColor}>{item.value}</Value>
            </MetadataRow>
          )
        })}
      </Box>
    </Wrapper>
  )
}

const Wrapper = styled(Box)`
  margin-top: 12px;
`

const LevelText = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$textcolor'
})<{ $textcolor: string }>`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
  color: ${(props) => props.$textcolor || '#222'};
`

const MetadataRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  height: 24px;
`

const Label = styled.span<{ $textcolor: string }>`
  color: ${(props) => {
    const baseColor = props.$textcolor || '#555'
    if (baseColor === '#ffffff' || baseColor === '#fff') {
      return 'rgba(255, 255, 255, 0.7)'
    }
    return baseColor
  }};
`

const Value = styled.span<{ $textcolor: string }>`
  font-weight: 500;
  color: ${(props) => props.$textcolor || '#222'};
`
